import { schema } from 'normalizr'
import {
  getEntity,
} from '@infotech/lib-api-middleware'
import { LOGGER_SERVICE } from './constants'

export const LOGS_SCHEMA_NAME = `logs`

export const apiUrl = `${LOGGER_SERVICE}/logs?limit=20`

export const logsSchema = new schema.Entity(LOGS_SCHEMA_NAME)

export const getObject = (state, id) => getEntity(state, LOGS_SCHEMA_NAME, id)
